import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import omit from 'lodash/omit';
import Icon from '../icon';
import CheckableTag from './CheckableTag';
import Animate from '../animate';
import { isPresetColor as isPresetColorUtil } from '../_util/colors';
import ConfigContext from '../config-provider/ConfigContext';
export { CheckableTagProps } from './CheckableTag';
export default class Tag extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            closing: false,
            closed: false,
            visible: true,
        };
        this.handleIconClick = (e) => {
            const { onClose } = this.props;
            if (onClose) {
                onClose(e);
            }
            if (e.defaultPrevented || 'visible' in this.props) {
                return;
            }
            this.setState({ visible: false });
        };
        this.close = () => {
            const { closing, closed } = this.state;
            if (closing || closed) {
                return;
            }
            const dom = findDOMNode(this);
            dom.style.width = `${dom.getBoundingClientRect().width}px`;
            // It's Magic Code, don't know why
            dom.style.width = `${dom.getBoundingClientRect().width}px`;
            this.setState({
                closing: true,
            });
        };
        this.show = () => {
            this.setState({
                closed: false,
            });
        };
        this.animationEnd = (_, existed) => {
            const { closed } = this.state;
            if (!existed && !closed) {
                this.setState({
                    closed: true,
                    closing: false,
                });
                const { afterClose } = this.props;
                if (afterClose) {
                    afterClose();
                }
            }
            else {
                this.setState({
                    closed: false,
                });
            }
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    static getDerivedStateFromProps(nextProps) {
        return ('visible' in nextProps) ? { visible: nextProps.visible } : null;
    }
    componentDidUpdate(_prevProps, prevState) {
        const { visible } = this.state;
        if (prevState.visible && !visible) {
            this.close();
        }
        else if (!prevState.visible && visible) {
            this.show();
        }
    }
    render() {
        const { prefixCls: customizePrefixCls, closable, color, className, children, style, ...otherProps } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('tag', customizePrefixCls);
        const { closing, closed } = this.state;
        const closeIcon = closable ? React.createElement(Icon, { type: "close", onClick: this.handleIconClick }) : '';
        const isPresetColor = isPresetColorUtil(color);
        const classString = classNames(prefixCls, {
            [`${prefixCls}-${color}`]: isPresetColor,
            [`${prefixCls}-has-color`]: color && !isPresetColor,
            [`${prefixCls}-close`]: closing,
        }, className);
        // fix https://fb.me/react-unknown-prop
        const divProps = omit(otherProps, [
            'onClose',
            'afterClose',
            'visible',
        ]);
        const tagStyle = {
            ...style,
        };
        if (color && !isPresetColor) {
            tagStyle.backgroundColor = color;
        }
        const tag = closed ? null : (React.createElement("div", Object.assign({ hidden: closing }, divProps, { className: classString, style: tagStyle }),
            children,
            closeIcon));
        return (React.createElement(Animate, { component: "", hiddenProp: "hidden", transitionName: `${prefixCls}-zoom`, transitionAppear: true, onEnd: this.animationEnd }, tag));
    }
}
Tag.displayName = 'Tag';
Tag.CheckableTag = CheckableTag;
Tag.defaultProps = {
    closable: false,
};
